import {InjectionToken, Provider} from '@angular/core';
export let HOLIDAYS_WEEKENDS_CHECK_SERVICE: any = new InjectionToken<HolidaysWeekendsCheckService>('tt.holidaysWeekendsCheckService');

export interface HolidaysWeekendsCheckService {
	isHoliday(date: string): boolean;
	isWeekend(date: string): boolean;
}

export function holidaysWeekendsCheckServiceFactory(i: any): any {
	return i.get('holidaysWeekendsCheckService');
}

export const holidaysWeekendsCheckServiceProvider: Provider = {
	provide: HOLIDAYS_WEEKENDS_CHECK_SERVICE,
	useFactory: holidaysWeekendsCheckServiceFactory,
	deps: ['$injector']
};



// WEBPACK FOOTER //
// ./src/app/shared/upgrade/holidays-weekends-check-service.service.ts